import Text from '../shared-components/Text';
import styles from './AboutMe.module.css';
import React from 'react';

function AboutMeSide() {
  return (
    <div className={styles.aboutmeTop}>
      <img
        className={styles.myFace}
        src="me-linked.jpeg"
        alt="A picture of what I look like. "
      />
      <h1 className={styles.nate}>Nate Kester</h1>
      <h2 className={styles.title}>Full Stack Engineer</h2>
      <div className={styles.socialMediaContainer}>
        <div className={styles.linksContainer}>
          <a className={styles.email} href="mailto:nate.d.kester@gmail.com">
            nate.d.kester@gmail.com
          </a>
          <a href="https://www.linkedin.com/in/nathan-kester-5512b193/">
            <img src="linkedinIcon.png" className={styles.linkedin} />
          </a>
        </div>
      </div>
      <h4 className={styles.sideDesc}>
        Hi, I’m Nate — a Full Stack Senior Software Engineer with a previous life in
        aerospace and semiconductor engineering.
      </h4>
    </div>
  );
}

export default AboutMeSide;
